import { Component, OnInit, Input, Inject, ViewEncapsulation } from '@angular/core'
import { ApiService } from '../../../core/services/api.service'
import { LayoutBreakpoins } from '../../../interfaces'
import { environment } from '../../../../environments/environment'
import { PLATFORM_ID } from '@angular/core'
import { isPlatformBrowser } from '@angular/common'
import { ChatState } from '../../../core/services/chat.service'
import { PageService } from 'src/app/core/services/page.service'
import { emailErrorMessage, sendAppLinkSuccessMessage, validateEmail } from 'src/app/core/helpers/app-link'
import { ElementRef } from '@angular/core'
import { AfterViewInit } from '@angular/core'
import { NGXLogger } from 'ngx-logger'
import { SendAppLinkService } from 'src/app/core/services/send-app-link.service'
import { checkIsInputArea } from 'src/app/core/helpers/fields-utils'
import * as _ from 'lodash'
import { LoginService } from 'src/app/modules/account/services/api/login.service'
import { NavigationEnd, Router } from '@angular/router'
import { SharedDataService } from 'src/app/core/services/shared-data.service'

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FooterComponent implements OnInit, AfterViewInit {
  cdn: string;
  dentalProviderInActive: boolean;
   activeTemplate : any = '';
  [x: string]: any
  constructor(
    private api: ApiService,
    private elementRef: ElementRef,
    @Inject(PLATFORM_ID)
    private platformId: any,
    private loginService: LoginService,
    public logger: NGXLogger,
    public router: Router,
    private chatState: ChatState,
    private sendAppLinkService: SendAppLinkService,
    public page: PageService,
    public sharedDataService: SharedDataService
  ) {
    //this.getRoute()
    this.loginService.authCheck()
    this.loginService.isLoggedIn.subscribe(
      (res) => {
        this.isLogged = res
      },
      (error: any) => {
        console.error(error)
      }
    )
    this.api.getFooter().subscribe(
      (res) => {
        this.year = new Date(Date.now()).getFullYear()
        this.footerInfo = res.data.attributes
        this.loadFooterInfo()
        this.api.modalPopupText = res.modalOptionPopupText
        this.api.modalPopupTextMobile = res.modalOptionPopupTextMobile
      },
      (error: any) => {
        console.error(error)
      }
    )
    this.equipmentProviderInActive = this.sharedDataService.getPortalType();
    if(this.equipmentProviderInActive){
      this.cdn = environment.API_EQUIP_PROVIDER_CDN_URL
    } else {
      this.cdn = environment.API_DENTAL_CDN_URL
    }
  }

  @Input() breakpoints: LayoutBreakpoins = {
    small: false,
    extraSmall: false,
    medium: false,
    large: true,
    extraLarge: false,
  }
 // cdn: string = environment.API_CDN_URL
  licensures: any[] = []
  lastUpdatedDate
  socialListIcons: any[] = [] 
  showLicensures = false
  footerInfo: any = {}
  year
  showLicense
  licenseImg
  licenseState
  isLogged: boolean = false

  private _showSended = false

  get showSended() {
    return this._showSended
  }

  set showSended(v: boolean) {
    this._showSended = v
    if (v === true) {
      setTimeout(() => {
        this._showSended = false
      }, 5000)
    }
  }


/*   getRoute(){
      this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        console.log('FOOTER: ' + e.url);
        this.captureRoute = e.url
         switch (true) {
          case this.captureRoute.indexOf('hsfs') > -1:
            // this.captureRoute = true
            // this.activateTemplate= this.hsfsTemplate;
            this.activeTemplate = 'hsfs'
           //this.routeAccountValidation = "hsfs/hsfs-account-activation"
            break;
          default:
            //this.captureRoute = false
            //this.activateTemplate = this.defaultTemplate;
            this.activeTemplate = 'dental'
            //this.routeAccountValidation = "account-activation"
            break;
        }
        // switch (this.captureRoute) {
        //   case "/hsfs":
        //     this.routeAccountValidation = "hsfs/account-activation"
        //     break;
        //   case "default":
        //     this.routeAccountValidation = "/account-activation"
        //     break;
        // } 
      }
    
    });
    //this.cdr.detectChanges();
  }
 */



  getCaptureRoute(route: any){
    this.activeTemplate =this.sharedDataService.getRoute()
    switch (this.activeTemplate) {
      case "hsfs":
        return `/hsfs/hsfs-`+route;
      default:
       return `/`+route;
    }
  }

  getMainRoute(route: any){
    this.activeTemplate =this.sharedDataService.getRoute()
    switch (this.activeTemplate) {
      case "hsfs":
       return `/`+route;
      default:
        return `/`;
    }
  }

  loadFooterInfo(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.footerInfo.leftColText) {
        this.footerInfo.leftColText = this.addNodeClass('ul', this.footerInfo.leftColText, 'list').outerHTML
        this.footerInfo.leftColTextAuthorized = this.addNodeClass('ul', this.footerInfo.leftColTextAuthorized, 'list').outerHTML
        this.footerInfo.midColumnText = this.setLicensureButton(this.footerInfo.midColumnText).outerHTML
        setTimeout(() => {
          document.querySelector('#licensures').addEventListener('click', () => {
            if(this.licensures.length){
              this.showLicensures = true
              this.page.scrollTo('footerLinks')
              return
            }
            this.api.getLicensures().subscribe(
              ({data}) => {
                this.licensures = data.attributes.licensures
                this.lastUpdatedDate = data.attributes.lastUpdated
                this.showLicensures = true
                this.page.scrollTo('footerLinks')
              },
              (error: any) => {
                console.error(error)
              }
            )
          })
        }, 50)
      }
    }
  }

  ngOnInit(): void {
    // this.loadFooterInfo()
    this.activeTemplate= this.sharedDataService.getRoute()

    this.equipmentProviderInActive = this.sharedDataService.getPortalType()
    if( this.equipmentProviderInActive){
      this.activeTemplate = 'hsfs';
    } else {
      this.activeTemplate = 'dental';
    }
    if(this.equipmentProviderInActive){
      document?.documentElement?.style?.setProperty('--background-color', '#0072BC')
      document?.documentElement?.style?.setProperty('--background-image', '../../../../../assets/hsfs/images/icons/shape.svg')
      document?.documentElement?.style?.setProperty('--vertical-footer-bgcolor', '')
      document?.documentElement?.style?.setProperty('--vertical-footer-divider', '#031A33')
      document?.documentElement?.style?.setProperty('--vertical-footer-border', '5.625px')
      document?.documentElement?.style?.setProperty('--vertical-footer-right-font', '400')
    } else {
      document?.documentElement?.style?.setProperty('--background-color', '#ea731f')
      document?.documentElement?.style?.setProperty('--background-image', '../../../../../assets/dental/images/icons/shape.svg')
      document?.documentElement?.style?.setProperty('--vertical-footer-bgcolor', '#F4F4F4')
      document?.documentElement?.style?.setProperty('--vertical-footer-divider', '#fff')
      document?.documentElement?.style?.setProperty('--vertical-footer-border', '5px + 0.2vw')
      document?.documentElement?.style?.setProperty('--vertical-footer-right-font', '500')
    }
  }

  ngAfterViewInit(): void {
    this.elementRef.nativeElement.querySelector('.footer').addEventListener('click', this.clickout.bind(this))
  }

  checkIsInputArea(target: HTMLElement) {
    return (
      target.parentElement.parentElement.classList.contains('input-area-f__active') ||
      target.parentElement.parentElement.classList.contains('input-area-f__inactive') ||
      target.classList.contains('input-area-f__active') ||
      target.classList.contains('input-area-f__inactive')
    )
  }

  clickout(event) {
    // console.log('footer clickout')
    let items = event.currentTarget.querySelectorAll("[class*='input-area']")
    if (checkIsInputArea(event.target)) {
      const filteredEl = event.target.parentElement.parentElement.querySelector('input')
      items = _.filter(items, (x) => !x.contains(filteredEl))
    }
    this.changeInputVisibleFooterStateAll(items)
  }

  addNodeClass(node: string, content: any, addClass: string) {
    const c = document?.createElement('div')
    // tslint:disable-next-line
    c.innerHTML = content.trim()
    const nodesCollection = c.querySelectorAll(node)
    // tslint:disable-next-line
    for (let i = 0; i < nodesCollection.length; i++) {
      nodesCollection[i].classList.add(addClass)
    }
    return c
  }

  navLinkToEl(page: string, elId: string) {
    this.page.showFaq = false
    this.page.goAndScroll(page, elId)
  }

  setLicensureButton(content: any) {
    if (isPlatformBrowser(this.platformId)) {
      const c = document?.createElement('div')
      // tslint:disable-next-line
      c.innerHTML = content.trim()
      const licensureNode = c.querySelector('[href*="licensure"]') as HTMLElement
      const licensureNodeChild = licensureNode?.firstElementChild as HTMLElement
      if (licensureNodeChild) {
        licensureNodeChild.classList.add('link')
        licensureNodeChild?.setAttribute('id', 'licensures')
        licensureNode.parentNode.replaceChild(licensureNodeChild, licensureNode)
      }
      return c
    }
  }

  toggleChat() {
    this.chatState.toggleChat(true)
  }

  closeLicensures() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.showLicensures = false
    setTimeout(() => {
      document.querySelector('#licensures').addEventListener('click', () => {
        this.showLicensures = true
        this.page.scrollTo('footerLinks')
      })
    }, 100)
  }

  toSendAppLinkEmailEvent(event) {
         if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const mailInput = document.querySelector('.inputDiv') as HTMLInputElement
    const mail = (document.getElementById('appLinkInputEmail') as any).value
    this.logger.info(mail)
    if (!validateEmail(mail)) {
      mailInput.classList.add('invalid')
      return
    }
    mailInput.classList.remove('invalid')
    this.sendAppLinkService.sendJoinIcwWrapper(mail)
    this.showSended = true
    const m = document.getElementById('appLinkInputEmail') as HTMLInputElement
    m.value = ''
    m.blur()
    setTimeout(() => {
      mailInput.classList.remove('input-area-f__active')
      mailInput.classList.add('input-area-f__inactive')
    }, 500)
  }

  inputItemClick(event: any): void {
    const tg = event.currentTarget
    if (!tg.classList) {
      return
    }
    tg.classList.toggle('updating')
    this.inputAriaFCheckActiveState(tg)
    setTimeout(() => {
      tg.classList.toggle('updating')
    }, 100)
  }

  inputAriaFCheckActiveState(targetElement: any, apply?: boolean): void {
    if (targetElement.classList.contains('input-area-f__inactive') || apply) {
      targetElement.classList.remove('input-area-f__inactive')
      targetElement.classList.add('input-area-f__active')
      if (!apply) {
        targetElement.querySelector('input').focus()
      }
    }
  }

  updateAreaActiveFooterDependsOnValue(el: HTMLElement): void {
    if (!el) {
      return
    }
    if (el.getAttribute('id') === 'inputItemWrapper' && el?.classList?.contains('updating')) {
      return
    }
    if (el.querySelector('input')?.value?.length > 0) {
      el.classList.remove('input-area-f__inactive')
      el.classList.add('input-area-f__active')
    } else {
      el.classList.add('input-area-f__inactive')
      el.classList.remove('input-area-f__active')
    }
  }

  changeInputVisibleFooterStateAll(arrayData: NodeList) {
    Array.prototype.forEach.call(arrayData, (el) => {
      const inputField = el.querySelector('input')
      if (inputField) {
        this.updateAreaActiveFooterDependsOnValue(el)
      }
    })
  }
  changeLicenseState(e){
    this.licenseState = e
  }
  showLicenseHeader(){
    this.showLicense = true
  }
  changeLicenseImage(e){
    this.licenseImg = e
  }
  closeLicense(){
    this.showLicense = false
  }
}
